/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSkill} from '../api'

 export const useQueryGetSkill = createReactQueryHook('getSkill', getSkill)
